import React from 'react'

const MunicipalityCreateListView = () => {
  return (
    <div>MunicipalityCreateListView</div>
  )
}

export default MunicipalityCreateListView